module.exports = __webpack_public_path__ + "static/media/striped_bar_WPC.95533581.svg";